import React, { useState, useEffect } from 'react';
import { toInteger } from 'lodash';
import numeral from 'numeral';



import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { FaFileImport } from "react-icons/fa";

import Page from 'src/components/Page';
import agm from '../../services/agm';

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';
import Import from './Import';
import Create from './Create';
import Treatment from './Treatment';



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  id: -1,
  codigo: null,
  IMPORTACAO: null,
  files: null
}

const defaultDependencies = {
  loaded: false,
  id: null,
  importacoes: [],
  estruturas: [],
  files: []
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const FATURAR = 6;

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Processo', field: 'formatNumber(item.id,"00000")', size: 10, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Nome', field: '(item.importacao) ? item.importacao.nome: "?"', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Arquivos', field: 'item.arquivos.length', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Processado', field: 'formatDatetime(item.processamento) + " por " + item.processador', size: 100, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Resultado', field: 'item.status', size: 1, sortable: 0, exportable: 0, wrap: 0 },
];

const defaultEmptyMessage = "Nenhum Processo de Importação Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_DISABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_ENABLED,
  export: LEVEL_ACCESS_HIDE,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_DISABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_ENABLED,
  export: LEVEL_ACCESS_HIDE,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Novos', refine: 1, label: 'Número da Ocorrência', history: 0 },
  { id: 2, name: 'Finalizadas', refine: 2, label: 'Número da Ocorrência', history: 1 },
  { id: 3, name: 'Erros', refine: 3, label: 'Número da Ocorrência', history: 1 }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0]
}

const defaultStatusRegister = {
  id: null,
  nome: null,
  usuario: null
}

const defaultStatusHistory = {
  registros: [],
  acoes: [],
  lotes: []
}

const defaultTretment = {
  processo: null,
  report: [],
  erros: [],
  contratos: [],
  tiposOcorrencia: [],
  tiposNota: [],
  categorias: [],
  statusOcorrencia: [],
  tiposAtendimento: [],
  statusEmpresa: [],
  sintomas: [],
  locaisSintomas: [],
}

const Imports = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);
  const [statusHistory, setStatusHistory] = useState(defaultStatusHistory);
  const [tratment, setTratment] = useState(defaultTretment);

  const [state, setState] = useState(defaultState);

  const openExportDialog = async (format) => {

  }

  const openEdition = (item) => {
    setItem(item);
    setItem(item);
    setMessage({
      title: 'Processar',
      message: 'Executar processo de importação selecionado?',
      warn: 'Esta ação pode demorar algum tempo. Se todos os dados forem encontrados e validados o processo de ' + item.importacao.nome + ' será finalizada com sucesso.'
    });
    setOpenEditionDialog(true);
  }

  const openCreation = async (item) => {
    setItem(item);
    await agm.post('/importacao/criacao', { item }, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            id: response.data.id,
            importacoes: response.data.importacoes,
            estruturas: response.data.estruturas,
            files: []
          }
        );
        item.id = response.data.id;
        item.codigo = numeral(response.data.id).format('00000');
        setItem(item);
        setOpenCreationDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const updateDependencies = (item) => {
    setItem(item);
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Importação',
      message: 'Deseja excluir o processo de importação selecionado?',
      warn: 'Esta ação irá remover todos os arquivos associados a ao processo de importação ' + item.importacao.nome + ' ' + numeral(item.id).format('00000') +
        '. Os dados não poderão mais ser recuperados.'
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = async (item) => {
    setItem(item)
    var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    await agm.post('/importacao/tratamento', { item, usuario }, {}).then((response) => {
      if (!response.data.error) {
        setTratment({
          processo: item,
          report: response.data.report,
          errors: []
        });
        setOpenTreatmentDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })

  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
    refreshItems();
  };

  const updateTreatmentValues = async (values) => {
    var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    await agm.post('/importacao/execute', { item, usuario }, {}).then((response) => {
      if (!response.data.error) {
        setTratment({
          processo: item,
          report: response.data.report,
          errors: response.data.errors,
        });
        alert(JSON.stringify(response.data.errors));
        setOpenTreatmentDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const updateValues = (values, items, removes) => {
    var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    closeEdition();
    agm.put('/importacao/' + values.id, { processo: values, usuario: usuario }).then((response) => {
      if (!response.data.error) {
        refreshItems();
        openTreatment(item);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values, estrutures, files) => {
    var user = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    const data = new FormData();
    data.append('values', JSON.stringify(values));
    data.append('estrutures', JSON.stringify(estrutures));
    data.append('user', user);
    for (let i = 0; i < files.length; i++) {
      data.append("files", files[i]);
    }
    agm.post('/importacao/criar', data, {}, { values, estrutures, user }).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };


  const deleteValues = (values) => {
    agm.delete('/importacao/' + values.id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const refreshItems = () => {
    filter.profile = localStorage.getItem('profile');
    agm.post('/importacao/historico', { filtro: filter }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
      profile: localStorage.getItem('profile')
    };
    setFilter(value);
    agm.post('/importacao/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (vision, keyword, page, rows, startDateTime, endDateTime) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision,
      profile: localStorage.getItem('profile')
    };
    setVision(vision);
    setFilter(value);
    agm.post('/importacao/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  return (
    <Page
      className={classes.root}
      title="Ocorrência"
    >

      <Container maxWidth={false}>

        <Toolbar
          icon={FaFileImport}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
          dependencies={dependencies}

        />

        <Alerts
          message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations
          item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Confirmations
          item={item}
          message={message}
          open={openEditionDialog}
          close={closeEdition}
          confirmation={updateValues} />

        <Treatment
          item={tratment}
          icon={FaFileImport}
          open={openTreatmentDialog}
          closeTreatment={closeTreatment}
          updateTreatmentValues={updateTreatmentValues}
          statusHistory={statusHistory}
          statusRegister={defaultStatusRegister}
        />

        <Import
          item={item}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
          selectedMode={selectedMode}
        />

        <Create
          item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={FaFileImport}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
                dependencies={dependencies}
              />
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Page>
  );
};

export default Imports;
